import logo from '../../../assets/images/logos/tech-mode-desktop.png';
import { FaFacebookSquare, FaInstagram } from 'react-icons/fa';
import { IoLogoWhatsapp } from 'react-icons/io5';
import { FaXTwitter } from 'react-icons/fa6';
import { Link, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

export function FooterPages({ data }) {
    const location = useLocation();
    const [route, setRoute] = useState();

    useEffect(() => {
        const currentRoute = location.pathname.substring(1);
        setRoute(currentRoute);
    }, [location]);

    return (
        <footer className='footer-home bg-section-primary py-5'>
            <div className='footer-home__image d-flex justify-content-center'>
                <Link to='/'>
                    <img className='footer-home__img' src={logo} alt='Logo Tech Mode' />
                </Link>
            </div>
            <div className='footer-home container py-4'>
                <ul className='footer-home__list row justify-content-md-between m-0 px-0'>
                    <li className={`footer-home__item col-sm-6 col-md-2 mb-3 mb-sm-0 px-sm-0 d-inline-flex justify-content-sm-center ${route === '' ? 'footer-home__item--active' : ''}`}>
                        <Link className='footer-home__item__link py-2 text-center' to='/'>Home</Link>
                    </li>
                    <li className={`footer-home__item col-sm-6 col-md-2 mb-3 mb-sm-0 px-sm-0 d-inline-flex justify-content-sm-center ${route === 'clientes' ? 'footer-home__item--active' : ''}`}>
                        <Link className='footer-home__item__link footer-home__item__link--disabled py-2 text-center' to='/clientes'>Clientes</Link>
                    </li>
                    <li className={`footer-home__item col-sm-6 col-md-2 mb-3 mb-sm-0 px-sm-0 d-inline-flex justify-content-sm-center ${route === 'nosotros' ? 'footer-home__item--active' : ''}`}>
                        <Link className='footer-home__item__link py-2 text-center' to='/nosotros'>Nosotros</Link>
                    </li>
                    <li className={`footer-home__item col-sm-6 col-md-2 mb-3 mb-sm-0 px-sm-0 d-inline-flex justify-content-sm-center ${route === 'portafolio' ? 'footer-home__item--active' : ''}`}>
                        <Link className='footer-home__item__link py-2 text-center' to='/portafolio'>Portafolio</Link>
                    </li>
                    <li className={`footer-home__item col-sm-6 col-md-2 mb-3 mb-sm-0 px-sm-0 d-inline-flex justify-content-sm-center ${route === 'contacto' ? 'footer-home__item--active' : ''}`}>
                        <Link className='footer-home__item__link py-2 text-center' to='/contacto'>Contacto</Link>
                    </li>
                </ul>
            </div>
            <div className='footer-home__box-separator container'>
                <hr className='footer-home__separator m-0' />
            </div>
            <div className='footer-home__social container pt-4'>
                <ul className='footer-home__social-list p-0 m-0 d-flex justify-content-center'>
                    <li className='footer-home__social-list__item'>
                        <a className='footer-home__social-list__item__link p-2 d-inline-flex' href={data.networksCompany[0]} aria-label='Enalace a Instagram' target='_blank' rel="noreferrer">
                            <FaInstagram />
                        </a>
                    </li>
                    <li className='footer-home__social-list__item'>
                        <a className='footer-home__social-list__item__link p-2 d-inline-flex' href={data.networksCompany[1]} aria-label='Enalace a Facebook' target='_blank' rel="noreferrer">
                            <FaFacebookSquare />
                        </a>
                    </li>
                    <li className='footer-home__social-list__item'>
                        <a className='footer-home__social-list__item__link p-2 d-inline-flex' href={data.networksCompany[2]} aria-label='Enalace a X' target='_blank' rel="noreferrer">
                            <FaXTwitter />
                        </a>
                    </li>
                    <li className='footer-home__social-list__item'>
                        <a className='footer-home__social-list__item__link p-2 d-inline-flex' href={data.networksCompany[3]} aria-label='Enalace a Whatsapp' target='_blank' rel="noreferrer">
                            <IoLogoWhatsapp />
                        </a>
                    </li>
                </ul>
                <p className='footer-home__social__text text-center mt-3 mb-0'>Tech Mode © 2024 - Todos los derechos reservados.</p>
            </div>
        </footer>
    );
}